import { gql } from 'graphql-tag';

export const GET_ACTIVE_ACCOUNTING_INTEGRATION = gql`
  query Id4891da1c6811a53439c5d2efe838cb57($companyId: ID!) {
    __typename
  }
`;

export const GET_ACCOUNTING_INTEGRATION_HISTORY = gql`
  query Id9a327215f1339bc2c9b8b58867b98175($companyId: ID!) {
    __typename
  }
`;

export const GET_AVAILABLE_ACCOUNTING_INTEGRATIONS = gql`
  query Idfe402cb1bb0abe0ee0fc12352a6f1766($companyId: ID!) {
    __typename
  }
`;
